import { getSnapshot, types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';
import { formatPhoneByLength, formatShortName } from 'utils';
import {
  AppealEmployeePhoneTypes,
  AppealFileContentTypes,
  AppealFileEncodingTypes,
} from '../constants';

export const IDNameModel = types.model('IDNameModel', {
  _id: types.optional(types.identifier, ''),
  name: types.optional(types.string, ''),
});

export const NameModel = types
  .model('NameModel', {
    first_name: types.optional(types.maybeNull(types.string), ''),
    last_name: types.optional(types.string, ''),
    patronymic_name: types.optional(types.maybeNull(types.string), null),
  })
  .views((self) => ({
    get fullName(): string {
      return `${self.last_name} ${self.first_name} ${
        self.patronymic_name ?? ''
      }`;
    },
    get shortName(): string {
      return formatShortName(this.fullName);
    },
  }));

export const AreaModel = types.model('AreaModel', {
  _id: types.optional(types.identifier, ''),
  number: types.optional(types.string, ''),
  formatted_number: types.optional(types.string, ''),
  floor_number: types.optional(types.maybeNull(types.number), 0),
  porch_number: types.optional(types.maybeNull(types.number), 0),
});

export const HouseModel = types.model('HouseModel', {
  _id: types.optional(types.identifier, ''),
  address: types.optional(types.string, ''),
});

export const PhoneModel = types
  .model('PhoneModel', {
    _type: types.optional(types.enumeration(AppealEmployeePhoneTypes), 'cell'),
    number: types.optional(types.string, ''),
    add: types.optional(types.maybeNull(types.string), null),
    code: types.optional(types.string, ''),
    str_number: types.optional(types.string, ''),
  })
  .views((self) => ({
    get formattedPhone() {
      return formatPhoneByLength(self.number);
    },
  }));

export const EmployeeModel = NameModel.props({
  _id: types.optional(types.string, ''),
  phone_numbers: types.optional(types.array(PhoneModel), []),
  email: types.optional(types.maybeNull(types.string), null),
  position: types.optional(IDNameModel, {}),
  department: types.optional(IDNameModel, {}),
})
  .views((self) => ({
    get snapshot() {
      return getSnapshot(self);
    },
  }))
  .actions((self) => ({
    updateField<K extends keyof typeof self.snapshot>(
      fieldName: K,
      value: (typeof self)[K]
    ) {
      self[fieldName] = value;
    },
  }))
  .named('Employee');

export const AppealFileModel = types
  .model('AppealsFile', {
    _id: types.optional(types.identifier, ''),
    shared_id: types.optional(types.maybeNull(types.string), null),
    name: types.optional(types.string, ''),
    content_type: types.optional(
      types.enumeration(AppealFileContentTypes),
      'application/octet-stream'
    ),
    tag: types.optional(types.string, 'unknown'),
    encoding: types.optional(
      types.enumeration(AppealFileEncodingTypes),
      'utf-8'
    ),
  })
  .volatile(() => ({
    downloadStatus: RequestStateModel.create(),
  }));
